module.exports = __webpack_public_path__ + "img/setting-other.19469537.png";